import React from 'react';
import { Form, Space, Upload, Button } from 'antd';
import { UploadOutlined, PictureOutlined, DeleteOutlined } from '@ant-design/icons';
import SectionKicker from './SectionKicker';
import { brand } from '../../styles/theme';

// Botones destructivos: rojo de marca sobre borde claro, como en la maqueta.
const destructiveStyle = {
  borderRadius: '6px',
  borderColor: brand.dangerBorder,
  color: brand.primary
};

const MediaSection = ({
  imageUrl,
  audioUrl,
  uploadingImage,
  uploadingAudio,
  onImageUpload,
  onAudioUpload,
  onImageRemove,
  onAudioRemove,
  onGalleryOpen
}) => {
  return (
    <div style={{ 
      marginBottom: 24, 
      paddingBottom: 16, 
      borderBottom: '2px solid #f0f0f0' 
    }}>
      <SectionKicker icon={PictureOutlined}>Contenido Multimedia</SectionKicker>

      {/* Campo de imagen */}
      <Form.Item
        label={
          <span style={{ 
            fontSize: '17px', 
            fontWeight: '600',
            color: '#262626',
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
            🖼️ Imagen del artículo (opcional)
          </span>
        }
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          {/* Vista previa de la imagen */}
          {imageUrl && (
            <div style={{ 
              border: '2px solid #d9d9d9', 
              borderRadius: '8px', 
              padding: '8px',
              backgroundColor: '#fafafa'
            }}>
              <img 
                src={imageUrl} 
                alt="article" 
                style={{ 
                  width: '100%', 
                  maxHeight: '400px',
                  objectFit: 'contain',
                  borderRadius: '6px' 
                }} 
              />
            </div>
          )}
          
          {/* Botones de acción */}
          <Space wrap className="cms-actions-inline">
            <Upload
              name="image"
              showUploadList={false}
              beforeUpload={onImageUpload}
              accept="image/*"
            >
              <Button
                icon={<UploadOutlined />}
                loading={uploadingImage}
                className="editor-action-btn"
                style={{ borderRadius: '6px' }}
              >
                {imageUrl ? 'Cambiar imagen' : 'Subir desde dispositivo'}
              </Button>
            </Upload>
            
            <Button
              icon={<PictureOutlined />}
              onClick={onGalleryOpen}
              className="editor-action-btn"
              style={{ borderRadius: '6px' }}
            >
              Buscar en Galería
            </Button>
            
            {imageUrl && (
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={onImageRemove}
                style={destructiveStyle}
              >
                Eliminar
              </Button>
            )}
          </Space>
        </Space>
      </Form.Item>

      {/* Campo de audio */}
      <Form.Item
        label={
          <span style={{ 
            fontSize: '17px', 
            fontWeight: '600',
            color: '#262626',
            display: 'flex',
            alignItems: 'center',
            gap: 6
          }}>
            🎵 Audio del artículo (opcional)
          </span>
        }
      >
        <Space direction="vertical" style={{ width: '100%' }}>
          <Upload
            name="audio"
            showUploadList={false}
            beforeUpload={onAudioUpload}
            accept="audio/*"
          >
            <Button
              icon={<UploadOutlined />}
              loading={uploadingAudio}
              className="editor-action-btn"
              style={{ borderRadius: '6px', height: '40px' }}
            >
              {audioUrl ? 'Cambiar audio' : 'Subir audio'}
            </Button>
          </Upload>
          {audioUrl && (
            <Space direction="vertical" style={{ width: '100%' }}>
              <audio controls style={{ width: '100%', borderRadius: '6px' }}>
                <source src={audioUrl} type="audio/mpeg" />
                Tu navegador no soporta el elemento audio.
              </audio>
              <Button
                danger
                size="small"
                icon={<DeleteOutlined />}
                onClick={onAudioRemove}
                style={destructiveStyle}
              >
                Eliminar audio
              </Button>
            </Space>
          )}
        </Space>
      </Form.Item>
    </div>
  );
};

export default MediaSection;

